import { useEffect, useRef, useState } from 'react';
import { LIFECYCLE } from '../../data/siteData';
import { prefersReducedMotion } from '../../hooks/useMotion';

const DURATION = 4200;

export const ProcessStepper = () => {
  const [current, setCurrent] = useState(0);
  const [playing, setPlaying] = useState(() => !prefersReducedMotion());
  const progRefs = useRef([]);

  useEffect(() => {
    if (!playing) return undefined;
    const id = setTimeout(() => setCurrent((c) => (c + 1) % LIFECYCLE.length), DURATION);
    return () => clearTimeout(id);
  }, [playing, current]);

  // Restart the progress bar on the active step each time it changes.
  useEffect(() => {
    progRefs.current.forEach((el, i) => {
      if (!el) return;
      el.style.transition = 'none';
      el.style.width = i < current ? '100%' : '0';
    });
    const active = progRefs.current[current];
    if (playing && active) {
      void active.offsetWidth;
      active.style.transition = `width ${DURATION}ms linear`;
      active.style.width = '100%';
    }
  }, [current, playing]);

  const step = LIFECYCLE[current];

  return (
    <div data-testid="process-stepper">
      <div className="steps" role="tablist" aria-label="BIM project lifecycle">
        {LIFECYCLE.map((s, i) => (
          <button
            key={s.title}
            type="button"
            role="tab"
            aria-selected={i === current}
            aria-controls="step-detail"
            onClick={() => setCurrent(i)}
          >
            <span className="n">{String(i + 1).padStart(2, '0')}</span>
            <b>{s.title}</b>
            <span className="prog" ref={(el) => { progRefs.current[i] = el; }} />
          </button>
        ))}
      </div>
      <div className="stepd fade" id="step-detail" role="tabpanel" key={current}>
        <div className="big">{String(current + 1).padStart(2, '0')}</div>
        <div>
          <h3>{step.title}</h3>
          <p>{step.text}</p>
        </div>
        <div className="out"><small>Output</small>{step.output}</div>
      </div>
      <button type="button" className="playctl" aria-pressed={playing} onClick={() => setPlaying((p) => !p)}>
        {playing ? '❚❚ Pause walkthrough' : '▶ Play walkthrough'}
      </button>
    </div>
  );
};

export default ProcessStepper;
